/* istanbul ignore file */
import React from 'react';
import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';
import { useLeaveUrl } from 'domain/people/leave/leaveRouting';

const EditLeaveButton = (props: EditButtonProps) => {
  const { getUpdateEntityUrl } = useLeaveUrl();

  return <EditButton path={id => getUpdateEntityUrl(id)} {...props} />;
};

export default EditLeaveButton;
